@let t = translate();

<big-ui-modal-frame
    [closeBtnTitle]="t.closeOverlayBtn"
    (closeModal)="popoverRef.close({ leaveForm: false })">
    <ng-container title>{{ title }}</ng-container>
    <ng-container content>
        <div class="flex flex-col gap-8">
            @if (image) {
                <div class="bg-primary-100 rounded-2xl dark:bg-transparent p-6">
                    <div class="max-w-85.5 mx-auto rounded-2xl bg-white p-4">
                        <big-ui-picture
                            [model]="image"
                            [contain]="true" />
                    </div>
                </div>
            }
            <div
                [innerHTML]="description | sanitize: securityContext"
                class="[&_>_*]:last:mb-0"></div>
            @if (link) {
                <div class="self-start">
                    <big-ui-link
                        [href]="link.uri"
                        [target]="'_blank'"
                        [linkClass]="'primary icon'">
                        <span>{{ t.showMore }}</span>
                        <big-icon
                            [icon]="linkIcon"
                            [size]="'w-4'"
                            class="shrink-0 fill-current" />
                    </big-ui-link>
                </div>
            }
        </div>
    </ng-container>
</big-ui-modal-frame>
